import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BrandMark } from '../../components/common/BrandMark';
import { useLanguage } from '../../i18n/useLanguage';

export const ShowSymbolPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const close = useCallback(() => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        close();
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [close]);

  return (
    <div
      className="show-symbol-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={t('static.showSymbol')}
    >
      <button
        type="button"
        className="show-symbol-close"
        onClick={close}
        aria-label={t('messages.modal.closeAria')}
      >
        ×
      </button>
      <BrandMark variant="hero" />
    </div>
  );
};
